// // import {
// //   ChevronDown,
// //   ChevronUp,
// // } from 'feather-icons-react/build/IconComponents'
// // import styles from './Action.module.sass'
// // import cn from 'classnames'
// // import { useState } from 'react'
// // import { useTranslation } from 'react-i18next'

// // const TriggerOrder = ({ isMarket, label, setTriggerPrice, triggerPrice }) => {
// //   const { t } = useTranslation()
// //   const [market, setMarket] = useState(false)
// //   // const [price, setPrice] = useState()

// //   const handleChangePriceIncreament = () => {
// //     const oldPrice = triggerPrice ?? 0
// //     setTriggerPrice(oldPrice + 0.1)
// //   }

// //   const handleChangePriceDecreament = () => {
// //     const oldPrice = triggerPrice ?? 0
// //     setTriggerPrice(oldPrice - 0.1)
// //   }

// //   return (
// //     <>
// //       <label
// //         className={cn('fieldNumber', styles.fieldNumber)}
// //         onClick={() => setMarket(false)}
// //       >
// //         <div className={styles.justifyDiv}>
// //           <div className={cn('label', styles.label)}>{t(label)}</div>
// //           {!market && (
// //             <input
// //               className={styles.input}
// //               type="number"
// //               name="total"
// //               value={triggerPrice}
// //               onChange={(e) => setTriggerPrice(e.target.value)}
// //             />
// //           )}
// //           <div className={styles.currency}>
// //             {market ? t('Market') : t('USDT')}
// //           </div>
// //         </div>
// //         <div className={cn('arrowButtons', styles.arrowButtons)}>
// //           <button
// //             type="button"
// //             className={cn('arrowUpButton', styles.arrowUpButton)}
// //             onClick={handleChangePriceIncreament}
// //           >
// //             <ChevronUp size="20" />
// //           </button>
// //           <button
// //             type="button"
// //             className={cn('arrowDownButton', styles.arrowDownButton)}
// //             onClick={handleChangePriceDecreament}
// //           >
// //             <ChevronDown size="20" />
// //           </button>
// //         </div>
// //       </label>
// //       {isMarket && (
// //         <label
// //           className={market ? styles.active : styles.field}
// //           onClick={() => setMarket(!market)}
// //         >
// //           {t('Market')}
// //         </label>
// //       )}
// //     </>
// //   )
// // }

// // export default TriggerOrder

// import {
//   ChevronDown,
//   ChevronUp,
// } from 'feather-icons-react/build/IconComponents'
// import styles from './Action.module.sass'
// import cn from 'classnames'
// import { useState } from 'react'
// import { useTranslation } from 'react-i18next'

// const TriggerOrder = ({ 
//   label, 
//   setTriggerPrice, 
//   triggerPrice, 
//   triggerOrderType, 
//   setTriggerOrderType,
//   price,
//   setPrice
// }) => {
//   const { t } = useTranslation()
//   const orderTypes = ['Limit', 'Market']

//   const handleTriggerPriceIncrement = () => {
//     const oldPrice = parseFloat(triggerPrice) || 0
//     setTriggerPrice((oldPrice + 0.1).toFixed(2))
//   }

//   const handleTriggerPriceDecrement = () => {
//     const oldPrice = parseFloat(triggerPrice) || 0
//     setTriggerPrice((oldPrice - 0.1).toFixed(2))
//   }

//   const handlePriceIncrement = () => {
//     const oldPrice = parseFloat(price) || 0
//     setPrice((oldPrice + 0.1).toFixed(2))
//   }

//   const handlePriceDecrement = () => {
//     const oldPrice = parseFloat(price) || 0
//     setPrice((oldPrice - 0.1).toFixed(2))
//   }

//   return (
//     <>
//       {/* Trigger Price Field with Up/Down buttons */}
//       <label className={cn('fieldNumber', styles.fieldNumber)}>
//         <div className={styles.justifyDiv}>
//           <div className={cn('label', styles.label)}>{t(label)}</div>
//           <input
//             className={styles.input}
//             type="number"
//             name="trigger"
//             value={triggerPrice}
//             onChange={(e) => setTriggerPrice(e.target.value)}
//             placeholder="0.00"
//           />
//           <div className={styles.currency}>{t('USDT')}</div>
//         </div>
//         <div className={cn('arrowButtons', styles.arrowButtons)}>
//           <button
//             type="button"
//             className={cn('arrowUpButton', styles.arrowUpButton)}
//             onClick={handleTriggerPriceIncrement}
//           >
//             <ChevronUp size="20" />
//           </button>
//           <button
//             type="button"
//             className={cn('arrowDownButton', styles.arrowDownButton)}
//             onClick={handleTriggerPriceDecrement}
//           >
//             <ChevronDown size="20" />
//           </button>
//         </div>
//       </label>

//       {/* Order Type Selection + Price */}
//       <div className={styles.orderTypeRow}>
//         <div className={styles.orderTypeSelector}>
//           {orderTypes.map((type) => (
//             <button
//               key={type}
//               type="button"
//               className={cn(styles.orderTypeButton, {
//                 [styles.activeOrderType]: triggerOrderType === type
//               })}
//               onClick={() => setTriggerOrderType(type)}
//             >
//               {t(type)}
//             </button>
//           ))}
//         </div>
        
//         <div className={styles.priceInputWrapper}>
//           <input
//             className={styles.priceInput}
//             type="number"
//             value={price}
//             onChange={(e) => setPrice(e.target.value)}
//             placeholder="Best price"
//             disabled={triggerOrderType === 'Market'}
//           />
//           {triggerOrderType === 'Limit' && (
//             <div className={styles.priceButtons}>
//               <button
//                 type="button"
//                 className={styles.priceUpButton}
//                 onClick={handlePriceIncrement}
//               >
//                 <ChevronUp size="16" />
//               </button>
//               <button
//                 type="button"
//                 className={styles.priceDownButton}
//                 onClick={handlePriceDecrement}
//               >
//                 <ChevronDown size="16" />
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   )
// }

// export default TriggerOrder

import {
  ChevronDown,
  ChevronUp,
} from 'feather-icons-react/build/IconComponents'
import styles from './Action.module.sass'
import cn from 'classnames'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const TriggerOrder = ({ 
  label = 'Trigger',
  setTriggerPrice, 
  triggerPrice, 
  triggerOrderType, 
  setTriggerOrderType, 
  price,
  setPrice
}) => {
  const { t } = useTranslation()
  // const [triggerOrderType, setTriggerOrderType] = useState('Limit') // Default to Limit order

  const handleTriggerPriceIncrement = () => {
    const oldPrice = parseFloat(triggerPrice) || 0
    setTriggerPrice((oldPrice + 0.1).toFixed(2))
  }

  const handleTriggerPriceDecrement = () => {
    const oldPrice = parseFloat(triggerPrice) || 0
    if (oldPrice > 0.1) {
      setTriggerPrice((oldPrice - 0.1).toFixed(2))
    }
  }

  const handlePriceIncrement = () => {
    const oldPrice = parseFloat(price) || 0
    setPrice((oldPrice + 0.1).toFixed(2))
  }

  const handlePriceDecrement = () => {
    const oldPrice = parseFloat(price) || 0
    if (oldPrice > 0.1) {
      setPrice((oldPrice - 0.1).toFixed(2))
    }
  }

  return (
    <>
      {/* Trigger Price Field with Up/Down buttons */}
      <label className={cn('fieldNumber', styles.fieldNumber)}>
        <div className={styles.justifyDiv}>
          <div className={cn('label', styles.label)}>{t(label)}</div>
          <input
            className={styles.input}
            type="number"
            name="trigger"
            value={triggerPrice||price}
            onChange={(e) => setTriggerPrice(e.target.value)}
            placeholder="0.00"
          />
          <div className={styles.currency}>{t('USDT')}</div>
        </div>
        <div className={cn('arrowButtons', styles.arrowButtons)}>
          <button
            type="button"
            className={cn('arrowUpButton', styles.arrowUpButton)}
            onClick={handleTriggerPriceIncrement}
          >
            <ChevronUp size="20" />
          </button>
          <button
            type="button"
            className={cn('arrowDownButton', styles.arrowDownButton)}
            onClick={handleTriggerPriceDecrement}
          >
            <ChevronDown size="20" />
          </button>
        </div>
      </label>

      {/* Order Type Selection */}
      <div className={styles.orderTypeRow}>
        <div className={styles.orderTypeSelector}>
          <button
            type="button"
            className={cn(styles.orderTypeButton, {
              [styles.activeOrderType]: triggerOrderType === 'Limit'
            })}
            onClick={() => setTriggerOrderType('Limit')}
          >
            {t('Limit')}
          </button>
          <button
            type="button"
            className={cn(styles.orderTypeButton, {
              [styles.activeOrderType]: triggerOrderType === 'Market'
            })}
            onClick={() => setTriggerOrderType('Market')}
          >
            {t('Market')}
          </button>
        </div>
      </div>

      {/* Price Input Field - Only shown and enabled for Limit orders */}
      <label className={cn('fieldNumber', styles.fieldNumber)}>
        <div className={styles.justifyDiv}>
          <div className={cn('label', styles.label)}>{t('Price')}</div>
          <input
            className={styles.input}
            type="number"
            name="price"
            value={triggerOrderType === 'Market' ? '' : price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder={triggerOrderType === 'Market' ? 'Market' : 'Best price'}
            disabled={triggerOrderType === 'Market'}
          />
          <div className={styles.currency}>{t('USDT')}</div>
        </div>
        {triggerOrderType === 'Limit' && (
          <div className={cn('arrowButtons', styles.arrowButtons)}>
            <button
              type="button"
              className={cn('arrowUpButton', styles.arrowUpButton)}
              onClick={handlePriceIncrement}
            >
              <ChevronUp size="20" />
            </button>
            <button
              type="button"
              className={cn('arrowDownButton', styles.arrowDownButton)}
              onClick={handlePriceDecrement}
            >
              <ChevronDown size="20" />
            </button>
          </div>
        )}
      </label>
    </>
  )
}

export default TriggerOrder